import {FC} from 'react'

// Every sample Excel carries a note on each column header (description, requirement, example and
// tax JSON key); this line tells users where to find it, with a mouse or on a phone (509).
const ExcelColumnGuideHint: FC<{className?: string}> = ({className = 'mt-4 mb-0'}) => (
  <p className={`text-gray-600 fs-7 ${className}`}>
    راهنمای هر ستون (توضیح، وضعیت، نمونه و کلید JSON) در یادداشت عنوان همان ستون در فایل آمده است؛
    برای دیدن آن، نشانگر را روی عنوان ستون نگه دارید یا در گوشی عنوان را لمس کنید.
  </p>
)

export {ExcelColumnGuideHint}
